import axios from 'axios';
import { serverConfig } from './server-config';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      location.reload();
    }
    return Promise.reject(error);
  }
);

export const UserService = {
  uploadUserDp: async (username, file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `https://${serverConfig.serverBaseAddress}/signite/internal-user/upload/dp?username=${username}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error uploading profile picture:", error.response?.data || error.message);
      throw error;
    }
  },

  deleteUserDp: async (username, path) => {
    try {
      const response = await axios.delete(
        `https://${serverConfig.serverBaseAddress}/signite/internal-user/delete/dp`,
        {
          params: {
            username: username,
            path: path
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting profile picture:", error.response?.data || error.message);
      throw error;
    }
  },
  getAllUsers: (page, size, username = '', role) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/internal-user/get/all?name=${username}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  getUserDetails: (userName) => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/internal-user/get/${userName}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  updateUserDetails: (user) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/internal-user/update`, user, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  addUser: (user) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/internal-user/add`, user, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  assignCandidate: (username, candidateId) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/assign-candidate?candidateId=${candidateId}&assignToUsername=${username}`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
};